import { Flex } from '@/_components';
import styles from './DeliveryPanelContainer.module.css';
import type { FC } from 'react';
import type { DeliveryPanelContainerProps } from './DeliveryPanelContainer.types';

export const DeliveryPanelContainer: FC<DeliveryPanelContainerProps> = ({
  children,
}) => {
  return <Flex className={styles.deliveryPanelContainer}>{children}</Flex>;
};
